module.exports = __webpack_public_path__ + "img/目标4.5474926d.png";